/* Native dialog manages focus containment and Escape for the mobile navigation. */
class AvNavigation extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.dialog = this.querySelector('dialog');
    this.opener = this.querySelector('[data-av-menu-open]');
    this.opener?.addEventListener('click', () => this.open(), { signal });
    this.querySelector('[data-av-menu-close]')?.addEventListener('click', () => this.close(), { signal });
    this.dialog?.addEventListener('close', () => {
      this.opener?.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('av-menu-open');
    }, { signal });
    this.dialog?.addEventListener('click', (event) => {
      if (event.target === this.dialog) {
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.close();
      }
      if (event.target.closest('a')) this.close();
    }, { signal });
    this.breakpoint = matchMedia('(min-width: 991px)');
    this.breakpoint.addEventListener('change', (event) => { if (event.matches) this.close(); }, { signal });
    const observer = new ResizeObserver(() => {
      document.body.style.setProperty('--header-height', `${this.offsetHeight}px`);
      document.body.style.setProperty('--header-group-height', `${this.offsetHeight}px`);
    });
    observer.observe(this);
    this.resizeObserver = observer;
    this.querySelectorAll('.av-header__dropdown').forEach((details) => {
      details.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') { details.open = false; details.querySelector('summary')?.focus(); }
      }, { signal });
    });
    document.addEventListener('click', (event) => {
      this.querySelectorAll('.av-header__dropdown[open]').forEach((details) => {
        if (!details.contains(event.target)) details.open = false;
      });
    }, { signal });
  }
  open() {
    if (!this.dialog || this.dialog.open) return;
    this.dialog.showModal();
    this.opener.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('av-menu-open');
  }
  close() { if (this.dialog?.open) this.dialog.close(); }
  disconnectedCallback() {
    this.close();
    this.controller?.abort();
    this.resizeObserver?.disconnect();
  }
}
if (!customElements.get('av-navigation')) customElements.define('av-navigation', AvNavigation);

/* Accordions become ordinary expanded columns on desktop. */
class AvFooter extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.breakpoint = matchMedia('(min-width: 750px)');
    const syncColumns = () => this.querySelectorAll('[data-av-footer-column]').forEach((details) => { details.open = this.breakpoint.matches; });
    syncColumns();
    this.breakpoint.addEventListener('change', syncColumns, { signal });
    this.querySelectorAll('[data-av-footer-column] > summary').forEach((summary) => summary.addEventListener('click', (event) => {
      if (this.breakpoint.matches) event.preventDefault();
    }, { signal }));
    this.querySelectorAll('.av-footer__localization').forEach((localization) => {
      const currentCountry = localization.querySelector('[role="option"][aria-current="true"]')
        || localization.querySelector('[role="option"][data-value]');
      if (currentCountry) {
        currentCountry.tabIndex = 0;
        // Horizon's Enter handler selects the option with aria-selected="true".
        currentCountry.setAttribute('aria-selected', 'true');
      }
    });
  }
  disconnectedCallback() { this.controller?.abort(); }
}
if (!customElements.get('av-footer')) customElements.define('av-footer', AvFooter);

function revealAnchoredDetails() {
  const fragment = window.location.hash.slice(1);
  if (!fragment) return;
  const target = document.getElementById(fragment);
  if (target instanceof HTMLDetailsElement) target.open = true;
}
revealAnchoredDetails();
window.addEventListener('hashchange', revealAnchoredDetails);
